import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { uploadFile } from "../../services/ieltsService";
import { isEmpty } from "../../untils/common/isEmpty";
import Recorder from "../PresenTations/share/Recorder/Recoder";
import "./checkMic.scss";

const CheckMic = () => {
  const [audioInput, setAudioInput] = useState(undefined);
  const [audioInputDevice, setAudioInputDevice] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [result, setResult] = useState([]);
  const navigate = useNavigate();
  console.log("🚀 ~ CheckMic ~ result:", isEmpty(result), !isEmpty(result));
  const canvasRef = useRef(null);
  const [counter, setCounter] = useState(0);

  const startStream = async () => {
    const audioSource = audioInput || undefined;
    let constraints = {
      audio: true,
      video: false,
    };
    if (audioInput) {
      constraints["audio"] = {
        deviceId: audioSource ? { exact: audioSource } : undefined,
      };
    }
    console.log("🚀 ~ startStream ~ constraints:", constraints);
    // navigator.mediaDevices
    //   .getUserMedia(constraints)
    //   .then(gotStream)
    //   .catch(handleError);
  };

  const handleError = (error) => {
    alert("Mic issue!");
    console.log("-----------error", error);
  };
  // const gotStream = (stream) => {
  //   console.log("🚀 ~ gotStream ~ stream:", stream);
  //   // setMediaStream(stream)
  //   getDevices();
  // };

  // const getDevices = () => {
  //   navigator.mediaDevices
  //     .enumerateDevices()
  //     .then(gotDevices)
  //     .catch(handleError);
  // };

  // const gotDevices = (deviceInfos) => {
  //   console.log("🚀 ~ gotDevices ~ deviceInfos:", deviceInfos);
  //   let audioDevice = [];
  //   for (let i = 0; i !== deviceInfos.length; ++i) {
  //     const deviceInfo = deviceInfos[i];
  //     if (deviceInfo.deviceId == "") {
  //       continue;
  //     }
  //     if (deviceInfo.kind === "audioinput") {
  //       audioDevice.push(deviceInfo);
  //     } else if (deviceInfo.kind === "audiooutput") {
  //     } else {
  //       console.log("Some other kind of source/device: ", deviceInfo);
  //     }
  //   }
  //   console.log("🚀 ~ gotDevices ~ audioDevice:", audioDevice);
  //   startRecording();
  // };

  const selectDevice = (event) => {
    console.log("🚀 ~ selectDevice ~ event:", event);

    localStorage.setItem("audioinput", event.target.value);
    setAudioInput(event.target.value);
    startStream();
  };

  const visualize = (analyser) => {
    const canvas = canvasRef.current;
    const canvasCtx = canvas.getContext("2d");
    let WIDTH = canvas.width;
    let HEIGHT = canvas.height;

    if (!analyser) return;
    analyser.fftSize = 2048;
    let bufferLength = analyser.fftSize;
    let dataArray = new Uint8Array(bufferLength);
    canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);
    let draw = function () {
      let drawVisual = requestAnimationFrame(draw);

      analyser.getByteTimeDomainData(dataArray);

      canvasCtx.fillStyle = "rgba(0, 240, 255, 0.15)";
      canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = "#FFFFFF";

      canvasCtx.beginPath();

      let sliceWidth = (WIDTH * 1.0) / bufferLength;

      let x = 0;

      for (let i = 0; i < bufferLength; i++) {
        let v = dataArray[i] / 128.0;
        let y = (v * HEIGHT) / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(canvas.width, canvas.height / 2);
      canvasCtx.stroke();
    };
    draw();
  };
  const startRecording = () => {
    Recorder.start((event) => {
      console.log("start", event);
      if (event.stream && event.analyser != null) {
        console.log("is recording");
        setCounter(0);
        setIsRecording(true);
        setResult([]);
        visualize(event.analyser);
      } else {
        alert(
          "Không connect được micro, hãy kiểm tra lại và reload lại trang!"
        );
      }
    });
  };

  const stopRecording = useCallback(() => {
    Recorder.stop(async (event) => {
      console.log("recorder success: ", event);
      visualize(null);
      let file = new File(
        [event.blob],
        `Speaking-${(Math.random() * 1000).toString()}.mp3`,
        { type: "audio/mp3" }
      );

      try {
        const res = await uploadFile(file, "media");
        setIsRecording(false);
        setResult([res.data]);
      } catch (error) {
        alert("update file issue!");
        console.log("Upload file error", error);
      }
    });
  }, []);

  useEffect(() => {
    let intervalId;
    if (isRecording) {
      intervalId = setInterval(() => {
        setCounter((counter) => counter + 1);
        if (isRecording && counter >= 10) {
          console.log("stop");
          stopRecording();
        }
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isRecording, counter, audioInputDevice, stopRecording]);

  const [userInfo] = useState(
    localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {}
  );
  const skill = localStorage.getItem("skill");

  const handleStartTest = () => {
    if (!userInfo) return alert("Username Requirements");
    navigate(skill);
  };

  useEffect(() => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((audios) => {
        const inputAudios = audios.filter(
          (audio) => audio.kind === "audioinput"
        );
        setAudioInputDevice(inputAudios);
      })
      .catch(handleError);
  }, []);

  return (
    <div>
      {isEmpty(result) && (
        <>
          <div className="btn-group mb-4">
            {isRecording ? (
              <div className="btn-get-started" onClick={() => stopRecording()}>
                <p>Dừng kiểm tra Micro</p>
              </div>
            ) : (
              <div className="btn-get-started" onClick={() => startRecording()}>
                <p>Bắt đầu kiểm tra Micro</p>
              </div>
            )}
          </div>

          <div className="box-visualize">
            <canvas
              ref={canvasRef}
              id="visualizeMic"
              className="w-100"
            ></canvas>
            {isRecording && (
              <select onChange={(e) => selectDevice(e)}>
                {audioInputDevice.map((e) => {
                  return (
                    <option key={e.deviceId + e?.label} value={e.deviceId}>
                      {e.label}
                    </option>
                  );
                })}
              </select>
            )}
          </div>
        </>
      )}
      {!isEmpty(result) && (
        <>
          <div className="btn-group mb-4">
            <div className="btn-again" onClick={() => setResult([])}>
              <p>Thử lại lần nữa</p>
            </div>
          </div>
          <div className="box-result d-flex justify-content-center mb-4">
            {result.map((e, index) => {
              return (
                <audio
                  key={index}
                  controls
                  src={process.env.REACT_APP_BE_HOST + e}
                ></audio>
              );
            })}
          </div>
          <div className="btn-group">
            {result && (
              <div className="btn-get-started" onClick={handleStartTest}>
                <p>Bắt đầu bài kiểm tra</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CheckMic;
